<template>
    <!-- 废弃机构id后的中转页 -->
    <transitPage v-if="showTransitPage" :orgInfo="orgInfo"></transitPage>
    <div class="main" :class="showEmpty?'not_found':'normal_main'" v-else>
        <img v-if="!showEmpty" class="logo_img_text" :src="orgInfo.logo" />
        <div v-if="!showEmpty" class="login_card clearfix">
            <!-- 左侧登录背景图 -->
            <div class="main-l"></div>
            <!-- 右部登录 -->
            <!-- loginMethed 登录方式 1-扫码 2-账号  3-扫码和账号 -->
            <div class="main-r">
                <img v-if="registerMode!='register' && (orgInfo.loginMethed == 1 || orgInfo.loginMethed == 3)" class="change-login-type-btn" :src="require(`../assets/images/${registerMode=='scanCode'?'img_zhanghao@2x.png':'img_saoma@2x.png'}`)" alt="" @click="creatQrcode">
                <!-- 只有一种登录方式：账号密码登录2 -->
                <!-- <div class="login_form login_form_small" v-if="orgInfo.loginMethed == 2">
                    <div class="login_text only_login_text">{{orgInfo.shortName?'欢迎登录'+(orgInfo.shortName).substr(0,6)+'管理系统':'欢迎登录后台管理系统'}}</div>
                    <div class="login_wrap">
                        <el-form ref="form" :model="loginForm" style="width:320px" :rules="rules">
                            <el-form-item label="" prop="userId">
                                <el-input class="userName" size="small" @input="inputChange" autofocus @mouseover="stopAccountTimer" @clear="inputClear" v-model="loginForm.userId" placeholder="请输入账号">
                                    <i slot="prefix" class="el-input__icon account_icon"></i>
                                </el-input>
                            </el-form-item>
                            <el-form-item label="" prop="passwd" :style="isShowCode?'margin-bottom:28px;':'margin-bottom:8px;'">
                                <el-input class="password" show-password size="small" v-model="loginForm.passwd" placeholder="请输入密码">
                                    <i slot="prefix" class="el-input__icon pwd_icon"></i>
                                </el-input>
                            </el-form-item>
                            <el-form-item label="" v-if="isShowCode" :prop="isShowCode ? 'validCode' : ''">
                                <el-input placeholder="请输入验证码" style="width:210px" size="small" v-model="loginForm.validCode" autocomplete='off' clearable></el-input>
                                <div class="getCodeBox"  @click="handleGedCode">
                                    <Button v-if="!isSend" size="large" class="" type="primary">
                                        获取验证码
                                    </Button>
                                    <img v-else :src="codeImg" alt="">
                                </div>
                                <p v-show="isSend" class="fr" style="text-align: left;color:#C8C8C8;line-height:0.7;">看不清？？点击图片更换下一张</p>
                            </el-form-item>
                            <el-form-item label="" style="text-align: left;">
                                <el-checkbox v-model="isSavePass">记住密码</el-checkbox>
                                <p class="forgetPass" @click="toForgetPass">忘记密码</p>
                            </el-form-item>
                        </el-form>
                        <el-button @click="submitForm" :loading="loading" class="login_btn" :class="isShowCode?'login_btn_showcode':'login_btn'" type="primary" round>登录</el-button>
                    </div>
                </div> -->
                <!-- 只有一种登录方式：扫码登录1 -->
                <!-- <div class="login_form" v-if="orgInfo.loginMethed == 1">
                    <div class="login_text">{{orgInfo.shortName?'欢迎登录'+(orgInfo.shortName).substr(0,6)+'管理系统':'欢迎登录后台管理系统'}}</div>
                    <div class="login_code_wrap">
                        <div>
                            <p v-show="showCode != 1">请使用曼哈顿APP扫一扫</p>
                            <p v-show="showCode == 1">请在App确认登录<span @click="codeRefresh" class="spanText">点击刷新</span></p>
                        </div>
                        <div class="one_way_code">
                            <img v-show="imgCode" src="../assets/images/code-backgound.png" id="testimg" style="width:220px" alt="">
                            <span v-show="!imgCode" id="qrcode" class="qrcode"></span>
                            <div v-show="showCode == 1" class="codeRefreshClass">
                                <img src="../assets/images/img-success.png" style="width:100px;margin-top: 30px;" alt="">
                                <p style="color:#000">扫码成功</p>
                            </div>
                            <div @click="codeRefresh" v-show="showCode == 2" class="codeRefreshClass">
                                <p style="margin-top: 94px;color:#000">二维码已过期</p>
                                <p style="color:#2A86F4">点击刷新</p>
                            </div>
                        </div>
                        <span class="spanText" @click="clickModalDownload">APP下载地址</span>
                    </div>
                </div> -->
                <!-- 两种登录方式 3-->
                <div class="'login_form">
                    <div class="login_text">{{registerMode=='register'?'手机号注册':(orgInfo.shortName?'欢迎登录'+(orgInfo.shortName).substr(0,6)+'管理系统':'欢迎登录后台管理系统')}}</div>
                    <div class="login_wrap_all">
                        <el-tabs :stretch="true" :value="registerMode" @tab-click="tabClick" style="width:320px;" v-show="registerMode!='scanCode' && registerMode!='register'">
                          <el-tab-pane label="密码登录" name="password"></el-tab-pane>
                          <el-tab-pane label="验证码登录" name="verificationCode"></el-tab-pane>
                          <!-- <el-tab-pane label="扫码登录" name="scanCode" :disabled="tabsDisabled"></el-tab-pane> -->
                        </el-tabs>
                        <!-- 扫码 -->
                        <div style="padding-top:4px;text-align: center" v-show="registerMode=='scanCode' && (orgInfo.loginMethed == 1 || orgInfo.loginMethed == 3)">
                            <div class="code" style="width:320px;">
                                <img v-show="imgCode" src="../assets/images/code-backgound.png" style="width:170px" alt="">
                                <span v-show="!imgCode" id="qrcode" class="qrcode"></span>
                                <div v-show="showCode == 1" class="codeRefreshClass2">
                                    <img src="../assets/images/img-success.png" style="width:100px;margin-top: 30px;" alt="">
                                    <p style="color:#000">扫码成功</p>
                                </div>
                                <div @click="codeRefresh" v-show="showCode == 2" class="codeRefreshClass2">
                                    <p style="margin-top: 94px;color:#000">二维码已过期</p>
                                    <p style="color:#2A86F4">点击刷新</p>
                                </div>
                            </div>
                            <div style="font-size:15px;color:#595656;padding-top: 4px;">
                                <p v-show="showCode != 1">请使用曼哈顿APP扫一扫</p>
                                <p v-show="showCode == 1">请在App确认登录<span @click="codeRefresh" class="spanText">点击刷新</span></p>
                            </div>
                            <span class="spanText" style="font-size: 15px;" @click="clickModalDownload">APP下载地址</span>
                        </div>
                        <!-- 账号密码 -->
                        <div :class="isShowCode?'paddingAPSmall':'paddingAPNormal'" v-show="registerMode=='password' && (orgInfo.loginMethed == 2 || orgInfo.loginMethed == 3)">
                                    <el-form ref="form" :model="loginForm" style="width:320px" :rules="rules">
                                        <el-form-item label="" prop="userId">
                                            <el-input class="userName" @input="inputChange" autofocus @mouseover="stopAccountTimer" @clear="inputClear" v-model="loginForm.userId" placeholder="请输入账号">
                                                <i slot="prefix" class="el-input__icon account_icon"></i>
                                            </el-input>
                                        </el-form-item>
                                        <el-form-item label="" prop="passwd" :style="isShowCode?'margin-bottom:22px;':'margin-bottom:10px;'">
                                            <el-input class="password" show-password v-model="loginForm.passwd" placeholder="请输入密码">
                                                <i slot="prefix" class="el-input__icon pwd_icon"></i>
                                            </el-input>
                                        </el-form-item>
                                        <el-form-item label="" v-if="isShowCode" :prop="isShowCode ? 'validCode' : ''">
                                            <el-input placeholder="请输入验证码" style="width:210px"  v-model="loginForm.validCode" autocomplete='off' clearable></el-input>
                                            <div class="getCodeBox"  @click="handleGedCode">
                                                <Button v-if="!isSend" size="large" class="" type="primary">
                                                    获取验证码
                                                </Button>
                                                <img v-else :src="codeImg" alt="">
                                            </div>
                                            <p v-show="isSend" class="fr" style="color:#C8C8C8;line-height:0.7;">看不清？？点击图片更换下一张</p>
                                        </el-form-item>
                                        <el-form-item  label="" style="text-align: left;">
                                            <el-checkbox v-model="isSavePass">记住密码</el-checkbox>
                                            <p class="forgetPass" @click="toForgetPass">忘记密码</p>
                                        </el-form-item>
                                    </el-form>
                                    <el-button @click="submitForm" :loading="loading" :class="isShowCode?'login_btn_showcode':'login_btn_all'" type="primary" round>登录</el-button>
                                </div>
                        <!-- 验证码 -->
                        <div v-show="registerMode == 'verificationCode'" class="paddingAPNormal">
                          <el-form ref="verificationCodeForm" :model="verificationCodeForm" style="width:320px" :rules="verificationCodeRules">
                              <el-form-item label="" prop="phone">
                                  <el-input class="userName" maxlength="11" v-model.trim="verificationCodeForm.phone" placeholder="请输入手机号">
                                      <i slot="prefix" class="el-icon-mobile-phone"></i>
                                  </el-input>
                              </el-form-item>
                              <el-form-item label="" prop="validCode" style="position: relative;">
                                  <el-input class="userName" maxlength="5" v-model.trim="verificationCodeForm.validCode" placeholder="请输入验证码">
                                      <i slot="prefix" class="el-icon-message"></i>
                                    </el-input>
                                    <el-button type="text" class="phone-valid-code-btn" @click="getCode(3)" :disabled="sendStatus">{{sendCodeText}}</el-button>
                                  </el-form-item>
                          </el-form>
                          <el-button style="margin-top:50px;" @click="verificationCodeSubmitForm" :loading="loading" class="login_btn_showcode" type="primary" round>登录</el-button>
                        </div>
                        <!-- 注册 -->
                        <div v-show="registerMode == 'register'" class="paddingAPNormal">
                          <el-form ref="registerForm" :model="registerForm" style="width:320px" :rules="verificationCodeRules">
                              <el-form-item label="" prop="phone">
                                  <el-input class="userName" maxlength="11" v-model.trim="registerForm.phone" placeholder="请输入手机号">
                                      <i slot="prefix" class="el-icon-mobile-phone"></i>
                                  </el-input>
                              </el-form-item>
                              <el-form-item label="" prop="code" style="position: relative;">
                                  <el-input class="userName" maxlength="5" v-model.trim="registerForm.code" placeholder="请输入验证码">
                                      <i slot="prefix" class="el-icon-message"></i>
                                    </el-input>
                                    <el-button type="text" class="phone-valid-code-btn" @click="getCode(3)" :disabled="sendStatus">{{sendCodeText}}</el-button>
                                  </el-form-item>
                          </el-form>
                          <el-button style="margin-top:50px;" @click="registerSubmitForm" :loading="loading" class="login_btn_showcode" type="primary" round>免费试用</el-button>
                        </div>
                    </div>
                    <div v-if="orgInfo.id==0 && registerMode != 'register'" class="register-btn">还没有账号？<span @click="registerMode='register'">免费注册</span></div>
                    <div v-if="registerMode == 'register'" class="register-btn"><span @click="haveAccount">已有账号登录</span></div>
                </div>
            </div>
        </div>
        <div v-if="showEmpty">
            <img class="not_found_img" src="../assets/images/not_found.png" />
        </div>
        <!-- 底部 -->
        <!-- <div v-if="!showEmpty" class="bottom_text">（C）2021-MSEDU 广州民云信息科技有限公司版权所有 粤ICP备19148754号 粤公网安备 44010502000307号</div> -->
        <el-dialog title="" :visible.sync="dialogVisible" width="530px">
            <div style="padding: 70px 38px 90px;font-size: 16px;font-weight: 400;color: #343537;">抱歉，暂时没有对应的系统权限，请联系管理员开通权限~</div>
        </el-dialog>
        <!-- 修改默认密码弹窗 -->
        <el-dialog title="温馨提示" :visible.sync="alterFormDialog" :close-on-click-modal="false" @close="closeDiv(1)" width="420px">
            <p>注意:您的密码当前依旧为默认密码，为了您的账号安全，请您先修改密码，提交后用新密码重新登录。已绑定私人手机号码不对的话请联系人事老师后台修改手机号。</p>
            <el-form ref="alterForm" :model="alterForm" style="width:100%" :rules="alterRules">
                <el-form-item  label="">
                    <el-input style="maxWidth:320px;" disabled autofocus :placeholder="'您的账号的为'+userId"></el-input>
                </el-form-item>
                <el-form-item  label="" prop="phone">
                    <el-input style="maxWidth:320px;" maxlength="11" autofocus v-model="alterForm.phone" placeholder="请输入手机号码"></el-input>
                </el-form-item>
                <el-form-item  label="" prop="code">
                    <el-input style="maxWidth:180px;" autofocus autocomplete="new-password" v-model="alterForm.code" placeholder="请输入验证码"></el-input>
                    <el-button type="primary" size="small" style="maxWidth:90px;marginLeft:20px" @click="getCode(1)" :disabled="sendStatus">{{sendCodeText}}</el-button>
                </el-form-item>
                <el-form-item  label="" prop="passwd">
                    <el-input style="maxWidth:320px;" show-password  v-model="alterForm.passwd" autocomplete="new-password" placeholder="8至18位数字+字母+符号组合密码"></el-input>
                </el-form-item>
                <el-form-item  label="" prop="confirmPasswd">
                    <el-input style="maxWidth:320px;" show-password  v-model="alterForm.confirmPasswd" autocomplete="new-password" placeholder="请再次输入确认修改后的密码"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="getSubmit">提 交</el-button>
            </div>
        </el-dialog>
        <!-- 获取手机验证码弹窗 -->
        <el-dialog title="温馨提示" :visible.sync="verificationDialog" :close-on-click-modal="false" @close="closeDiv(2)" width="380px">
            <p>你好，为了你的账号安全，请输入手机验证码</p>
            <el-form ref="verificationForm" :model="verificationForm" style="width:100%" :rules="verificationRules">
                <el-form-item  label="" prop="phone">
                    <el-input style="maxWidth:320px;" maxlength="11" :disabled="true" autofocus v-model="verificationForm.phone" placeholder="请输入手机号码"></el-input>
                </el-form-item>
                <el-form-item  label="" prop="validCode">
                    <el-input style="maxWidth:180px;" autofocus autocomplete="new-password" clearable :disabled="butInput" v-model.trim="verificationForm.validCode" placeholder="请输入验证码"></el-input>
                    <el-button type="primary" size="small" style="maxWidth:90px;marginLeft:20px" @click="getCode(2)" :disabled="sendStatus">{{sendCodeText}}</el-button>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="getVerification" :loading="btnLoading">提 交</el-button>
            </div>
        </el-dialog>
        <!-- 拖动图片获取验证码弹窗 -->
        <el-dialog
            :visible.sync="modalStatus"
            title="完成拼图验证"
            width="335px">
            <puzzle :on-success="onSuccess"  width="260" height="120" />
        </el-dialog>
        <!-- 下载地址弹窗 -->
        <el-dialog title="曼哈顿APP" :visible.sync="modalDownload" width="330px" style="text-align:center">
            <div style="width:290px;text-align:center">
                <div style="margin-top:20px;font-size: 16px;color: #343537;">请使用手机浏览器或微信扫一扫</div>
                <div style="margin-top:20px;margin-bottom:28px;">
                    <img src="../assets/images/code-backgound.png" style="width:170px;margin:0 auto" alt="">
                </div>
                <div style="margin-bottom: 20px;"><a href="https://study.mshiedu.com/crmpage/manIOSGuide" target="_blank">安装操作指引</a> </div>
            </div>
        </el-dialog>
        <!-- 选择机构模态框 -->
        <selectOrgModal ref="selectOrgModal" @showCompleteOrgModal="showCompleteOrgModal"></selectOrgModal>
        <!-- 完善信息模态框 -->
        <completeOrgModal ref="completeOrgModal"></completeOrgModal>
    </div>
</template>

<script>
import {
  Button, Form, Input, FormItem, Checkbox, Dialog, Message, Tabs, TabPane, Loading,
} from 'element-ui';
import puzzle from '@/components/puzzle.vue';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import QRCode from 'qrcodejs2';
import api from '../api/index';
import transitPage from './transitPage.vue';
import selectOrgModal from './selectOrgModal.vue'
import completeOrgModal from './completeOrgModal.vue'

export default {
  name: 'home',
  components: {
    'el-button': Button,
    'el-form': Form,
    'el-input': Input,
    'el-form-item': FormItem,
    'el-checkbox': Checkbox,
    'el-dialog': Dialog,
    'el-tabs': Tabs,
    'el-tab-pane': TabPane,
    swiper,
    swiperSlide,
    puzzle,
    transitPage,
    selectOrgModal,
    completeOrgModal,
  },
  data() {
    const validateName = (rule, value, callback = function () {
    }) => {
      if (!value) {
        return callback(new Error('请填写有效账户'));
      }
      callback();
    };
    const validatePassword = (rule, value, callback = function () {
    }) => {
      if (!value || value.length < 6) {
        return callback(new Error('请输入密码'));
      }
      callback();
    };
    const validateMobile = (rule, value, callback = function () {
    }) => {
      const reg = new RegExp(/^[0-9]*$/);
      if (!value || value.length != 11 || !reg.test(value)) {
        return callback(new Error('请填写有效手机号'));
      }
      callback();
    };
    const validateAuthCode = (rule, value, callback = function () {
    }) => {
      if (!value) {
        return callback(new Error('请填写验证码'));
      }
      callback();
    };
    const validateCipher = (rule, value, callback = function () {
    }) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (value.length < 8 || this.$tool.verificationPassWord(value)) {
        callback('输入8至18位数字+字母+符号组合密码');
      } else {
        callback();
      }
    };
    const validateAgainCipher = (rule, value, callback = function () {
    }) => {
      // const reg = new RegExp(/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/);
      // if (!value || !reg.test(value)) {
      //   return callback(new Error('请填写确认修改后的密码'));
      // } if (!value || value != this.alterForm.passwd) {
      //   return callback(new Error('输入密码不一致'));
      // }
      // callback();
      if (value === '') {
        callback(new Error('请输入密码'));
      }else if (!value || value != this.alterForm.passwd) {
        return callback(new Error('输入密码不一致'));
      }
       else {
        callback();
      }
    };
    return {
      orgInfo: {}, // 机构信息
      showEmpty: false, // 显示空态图
      loginModules: [], // 登录模块列表集合
      moduleId: 12, // 模块id，新慧简学系统为12
      verifyType: 0, // 登录校验返回的结果类型：0表示需要展示登录模块（即取loginModules字段内容），1表示直接跳转登录
      alterFormDialog: false, // 修改密码弹窗显示与否
      verificationDialog: false, // 发生验证码弹窗显示与否
      btnLoading: false,
      alterForm: {
        phone: null, // 用户私人手机
        code: '',
        passwd: '',
        confirmPasswd: '',
      }, // 修改密码弹窗
      verificationForm: { // 验证码弹窗表单
        phone: null,
        validCode: '',
      },
      butInput: true,
      userId: null, // 用户id
      modalStatus: false, // 图片验证弹窗
      sendCodeText: '获取验证码',
      sendStatus: false, // 发送按钮禁用状态
      openStatus: true,
      prevEnd: true,
      prevNext: false,
      loading: false, // 登录loading
      userIcon: require('../assets/images/account.png'),
      passwordIcon: require('../assets/images/password.png'),
      codeImg: '',
      loginForm: {
        userId: window.localStorage.getItem('userInfo') ? JSON.parse(window.localStorage.getItem('userInfo')).userId : '',
        passwd: window.localStorage.getItem('userInfo') ? JSON.parse(window.localStorage.getItem('userInfo')).passwd : '',
        module: 'hjx_s2b_platform',
      },
      // 验证码登录
      verificationCodeForm:{
        phone:'',
        validCode:'',
      },
      // 注册
      registerForm:{
        phone:'',
        code:'',
      },
      verificationCodeRules: {
        phone: [{ required: true, validator: validateMobile, trigger: 'blur' }],
        validCode: [{ required: true, validator: validateAuthCode, trigger: 'blur' },],
      },
      show: true,
      isSavePass: true,
      isShowCode: false, // 是否显示验证码输入框
      isSend: false,
      dialogVisible: false, // 抱歉，暂时没有对应的系统权限，请联系管理员开通权限 弹框
      titleImageData: [
        {
          num: 1, id: 1, url: require('../assets/images/manhadun_title.png'), text: '曼哈顿系统',
        },
        {
          num: 2, id: 2, url: require('../assets/images/center_title.png'), text: '中枢系统',
        },
        {
          num: 3, id: 3, url: require('../assets/images/server_title.jpg'), text: 'AI服务系统',
        },
        {
          num: 4, id: 11, url: require('../assets/images/jiaowu_title.jpg'), text: '教务系统',
        },
        {
          num: 5, id: 4, url: require('../assets/images/study_title.png'), text: 'POKO柏克学',
        },
        {
          num: 6, id: 5, url: require('../assets/images/exam_title.png'), text: 'AI学习',
        },
        {
          num: 7, id: 6, url: require('../assets/images/pareto@2x.png'), text: 'Pareto BI',
        },
        {
          num: 8, id: 7, url: require('../assets/images/operate_title.png'), text: '运营支持中心',
        },
        {
          num: 9, id: 8, url: require('../assets/images/knoledge_before_title.png'), text: '知识树',
        },
        {
          num: 10, id: 9, url: require('../assets/images/knoledge_back_title.png'), text: '知识树后台',
        },
        {
          num: 11, id: 10, url: require('../assets/images/ad_title.png'), text: '广告系统',
        },
      ],
      systemData: [],
      systemData1: [
        {
          num: 1,
          id: 1,
          url: require('../assets/images/manhadun@2x.png'),
          text: '曼哈顿系统',
          enterUrl: require('../assets/images/manhadun_sel@2x.png'),
          locationUrl: `${process.env.VUE_APP_LOCALTION_URL}/manhattanstatic/#/login`,
          module: 'manhattan',
          QRcode: 'xxx',
        },
        {
          num: 2,
          id: 2,
          url: require('../assets/images/zhongshu@2x.png'),
          text: '中枢系统',
          enterUrl: require('../assets/images/zhongshu_sel@2x.png'),
          locationUrl: `${process.env.VUE_APP_LOCALTION_URL}/centerstatic/#/login`,
          module: 'zhongshu',
          QRcode: '',
        },
        {
          num: 3,
          id: 3,
          url: require('../assets/images/Edu@2x.png'),
          text: 'AI服务系统',
          enterUrl: require('../assets/images/Edu_sel@2x.png'),
          locationUrl: `${process.env.VUE_APP_LOCALTION_URL}/jiaowustatic/#/login`,
          module: 'jiaowu',
          QRcode: 'ccc',
        },
        {
          num: 4,
          id: 11,
          url: require('../assets/images/jiaowu.png'),
          text: '教务系统',
          enterUrl: require('../assets/images/Edu_sel@2x.png'),
          locationUrl: `${process.env.VUE_APP_LOCALTION_URL}/jiaowuadmin/#/login`,
          module: 'academic',
          QRcode: '',
        },
        {
          num: 5,
          id: 4,
          url: require('../assets/images/study@2x.png'),
          text: 'POKO柏克学',
          enterUrl: require('../assets/images/study_sel@2x.png'),
          locationUrl: `${process.env.VUE_APP_LOCALTION_URL}/studystatic/#/login`,
          module: 'study',
          QRcode: 'aaa',
        },
        {
          num: 6,
          id: 5,
          url: require('../assets/images/exam@2x.png'),
          text: 'AI学习',
          enterUrl: require('../assets/images/exam_sel@2x.png'),
          locationUrl: `${process.env.VUE_APP_LOCALTION_URL}/examadmin/#/login`,
          module: 'exam',
          QRcode: '',
        },
        {
          num: 7,
          id: 6,
          url: require('../assets/images/BI@2x.png'),
          text: 'Pareto BI',
          enterUrl: require('../assets/images/BI@2x.png'),
          locationUrl: `${process.env.VUE_APP_LOCALTION_URL}/paretostatic/#/login`,
          module: 'pareto',
          QRcode: 'xxx',
        },
        {
          num: 8,
          id: 7,
          url: require('../assets/images/operate@2x.png'),
          text: '运营支持中心',
          enterUrl: require('../assets/images/operate_sel@2x.png'),
          locationUrl: `${process.env.VUE_APP_LOCALTION_URL}/marketstatic/#/login`,
          module: 'market',
          QRcode: '',
        },
        {
          num: 9,
          id: 8,
          url: require('../assets/images/knowledge_before@2x.png'),
          text: '知识树',
          enterUrl: require('../assets/images/knowledge_before_sel@2x.png'),
          locationUrl: `${process.env.VUE_APP_LOCALTION_URL}/libraryWeb/#/login`,
          module: 'library',
          QRcode: '',
        },
        {
          num: 10,
          id: 9,
          url: require('../assets/images/knowledge_back@2x.png'),
          text: '知识树后台',
          enterUrl: require('../assets/images/knowledge_back_sel@2x.png'),
          locationUrl: `${process.env.VUE_APP_LOCALTION_URL}/libraryAdmin/#/login`,
          module: 'library-admin',
          QRcode: '',
        },
        {
          num: 11,
          id: 10,
          url: require('../assets/images/ad_back.png'),
          text: '广告系统',
          enterUrl: require('../assets/images/knowledge_back_sel@2x.png'),
          locationUrl: `${process.env.VUE_APP_LOCALTION_URL}/adstatic/#/login`,
          module: 'advert',
          QRcode: '',
        },
        {
          num: 12,
          id: 12,
          url: require('../assets/images/ad_back.png'),
          text: '慧简学系统',
          enterUrl: require('../assets/images/knowledge_back_sel@2x.png'),
          locationUrl: `${process.env.VUE_APP_LOCALTION_URL}/menu/#/login`,
          module: 'hjx_s2b_platform',
          QRcode: '',
        },
      ],
      signArr: ['manhattan', 'zhongshu', 'jiaowu', 'academic', 'study', 'exam', 'pareto', 'market', 'library', 'library-admin', 'advert', 'hjx_s2b_platform'],
      systemData2: [ // 这里就写线上地址咯
        {
          num: 1,
          id: 1,
          url: require('../assets/images/manhadun@2x.png'),
          text: '曼哈顿系统',
          enterUrl: require('../assets/images/manhadun_sel@2x.png'),
          locationUrl: 'https://sys.myunedu.com/manhattanstatic/#/login',
          module: 'manhattan',
          QRcode: 'xxx',
        },
        {
          num: 2,
          id: 2,
          url: require('../assets/images/zhongshu@2x.png'),
          text: '中枢系统',
          enterUrl: require('../assets/images/zhongshu_sel@2x.png'),
          locationUrl: 'https://sys.myunedu.com/centerstatic/#/login',
          module: 'zhongshu',
          QRcode: '',
        },
        {
          num: 3,
          id: 3,
          url: require('../assets/images/Edu@2x.png'),
          text: 'AI服务系统',
          enterUrl: require('../assets/images/Edu_sel@2x.png'),
          locationUrl: 'https://sys.myunedu.com/jiaowustatic/#/login',
          module: 'jiaowu',
          QRcode: 'ccc',
        },
        {
          num: 4,
          id: 11,
          url: require('../assets/images/jiaowu.png'),
          text: '教务系统',
          enterUrl: require('../assets/images/Edu_sel@2x.png'),
          locationUrl: 'https://sys.myunedu.com/jiaowuadmin/#/login',
          module: 'academic',
          QRcode: '',
        },
        {
          num: 5,
          id: 4,
          url: require('../assets/images/study@2x.png'),
          text: 'POKO柏克学',
          enterUrl: require('../assets/images/study_sel@2x.png'),
          locationUrl: 'https://sys.myunedu.com/studystatic/#/login',
          module: 'study',
          QRcode: 'aaa',
        },
        {
          num: 6,
          id: 5,
          url: require('../assets/images/exam@2x.png'),
          text: 'AI学习',
          enterUrl: require('../assets/images/exam_sel@2x.png'),
          locationUrl: 'https://sys.myunedu.com/examadmin/#/login',
          module: 'exam',
          QRcode: '',
        },
        {
          num: 7,
          id: 6,
          url: require('../assets/images/BI@2x.png'),
          text: 'Pareto BI',
          enterUrl: require('../assets/images/BI@2x.png'),
          locationUrl: 'https://sys.myunedu.com/paretostatic/#/login',
          module: 'pareto',
          QRcode: 'xxx',
        },
        {
          num: 8,
          id: 7,
          url: require('../assets/images/operate@2x.png'),
          text: '运营支持中心',
          enterUrl: require('../assets/images/operate_sel@2x.png'),
          locationUrl: 'https://sys.myunedu.com/marketstatic/#/login',
          module: 'market',
          QRcode: '',
        },
        {
          num: 9,
          id: 8,
          url: require('../assets/images/knowledge_before@2x.png'),
          text: '知识树',
          enterUrl: require('../assets/images/knowledge_before_sel@2x.png'),
          locationUrl: 'https://sys.myunedu.com/libraryWeb/#/login',
          module: 'library',
          QRcode: '',
        },
        {
          num: 10,
          id: 9,
          url: require('../assets/images/knowledge_back@2x.png'),
          text: '知识树后台',
          enterUrl: require('../assets/images/knowledge_back_sel@2x.png'),
          locationUrl: 'https://sys.myunedu.com/libraryAdmin/#/login',
          module: 'library-admin',
          QRcode: '',
        },
        {
          num: 11,
          id: 10,
          url: require('../assets/images/ad_back.png'),
          text: '广告系统',
          enterUrl: require('../assets/images/knowledge_back_sel@2x.png'),
          locationUrl: 'https://sys.myunedu.com/adstatic/#/login',
          module: 'advert',
          QRcode: '',
        },
        {
          num: 12,
          id: 12,
          url: require('../assets/images/ad_back.png'),
          text: '慧简学系统',
          enterUrl: require('../assets/images/knowledge_back_sel@2x.png'),
          locationUrl: 'https://sys.myunedu.com/menu/#/login',
          module: 'hjx_s2b_platform',
          QRcode: '',
        },
      ],
      rotaryBtn: [
        { id: 1 },
        { id: 2 },
      ],
      checkItem: 1,
      checkCardItem: 1,
      locationUrl: window.adminUrl?`${window.adminUrl}/menu/#/login`:(`${process.env.NODE_ENV}` === 'production' ? 'https://sys.myunedu.com/menu/#/login' : `${process.env.VUE_APP_LOCALTION_URL}/menu/#/login`),
      mouseIndex: 1,
      showNoQRcode: 0,
      rotaryBoxStyle: {},
      rules: {
        userId: [
          { validator: validateName, trigger: 'blur' },
        ],
        passwd: [
          { validator: validatePassword, trigger: 'blur' },
        ],
        validCode: [
          { required: true, validator: validateAuthCode, trigger: 'blur' },
        ],
      },
      alterRules: {
        phone: [{ validator: validateMobile, trigger: 'blur' }],
        code: [{ validator: validateAuthCode, trigger: 'blur' }],
        passwd: [{ validator: validateCipher, trigger: 'blur' }],
        confirmPasswd: [{ validator: validateAgainCipher, trigger: 'blur' }],
      },
      verificationRules: {
        phone: [{ required: true, validator: validateMobile, trigger: 'blur' }],
        validCode: [{ required: true, validator: validateAuthCode, trigger: 'blur' }],
      },
      // modalSelSys:false,    //选择系统进入弹窗显示与否
      interval: null, // 验证码定时器
      modalDownload: false, // 下载弹窗显示与否
      showCode: 0, // 二维码显示状态切换    0：二维码、1：扫码成功、2：验证码过期
      codeSetInterval: null, // 二维码定时器
      registerMode: 'password',//verificationCode-验证码登录password-密码登录；scanCode-扫码登录；；register-注册；
      tabsDisabled: false,
      imgCode: false, // 是否展示默认二维码
      qrcodeData: { // 生成二维码所带的参数
        qrcodeId: '',
        sysModuleId: 12,
      },
      websock: null,
      qrcode: null,
      qrcodesetInterval: null, // 心跳定时器
      ifInterval: false, // 是否启动定时器
    };
  },
  computed: {
    /* 
      关于域名的3个情况
      1.当前地址是旧的域名，没有独立域名，在旧的域名登录
      2.当前地址是旧的域名，已经有独立域名，跳去引导页
      3.当前地址是旧的域名，且拉入黑名单了，跳去404
    */
    // 是否展示中转页
    showTransitPage(){
      let flag = false
      if(!window.isDomain && this.orgInfo.id){//旧域名
        if(this.orgInfo.cancelRentId==1){//情况-3
          this.showEmpty = true
          flag = false
        }else{
          if (this.orgInfo.adminUrl.includes('/id') || this.orgInfo.adminUrl.includes('id=')) {//情况-1
            flag = false
          }else{//情况-2
            flag = true
          }
        }
      }
      return flag
    }
  },
  created() {
    if (`${process.env.NODE_ENV}` === 'production') {
      this.systemData = this.systemData2;
    } else {
      this.systemData = this.systemData1;
    }
    if (window.rentId) { // 带有id才请求机构信息
      this.showEmpty = false;
      localStorage.setItem('ALLrentId', window.rentId);// url上的id存起来，并给ALLrentId设值
      this.getOrgInfo();
    } else {
      this.showEmpty = true;
    }
    if(window.getQueryString2('registerMode') =='register'){//带注册参数过来
      this.registerMode = 'register'
    }else{
      if (window.localStorage.getItem('registerMode')) {
        this.tabsDisabled = false;
        this.registerMode = window.localStorage.getItem('registerMode');
        if (this.registerMode == 'scanCode') {
          this.getQrcode();
        }
      }
    }
  },
  mounted() {
  },
  methods: {
    stopAccountTimer() {
      if (window.canNotSetShowCodeFalseTimer) {
        window.clearTimeout(window.canNotSetShowCodeFalseTimer);
        window.canNotSetShowCodeFalseTimer = null;
      }
      window.canNotSetShowCodeFalse = false;
    },
    getOrgInfo() { // 获取机构基本信息(登录前)
      if(rentId==0){
        this.orgInfo = {
          id:0,
          loginMethed:3,
          shortName:'慧简学',
          logo:require('../assets/images/hjx_logo@2x.png')
        }
        return
      }
      api.getOrgInfo({rentId:window.rentId}, (res) => {
        // console.log('获取机构基本信息(登录前)res',res)
        this.orgInfo = res;
        if (this.orgInfo.loginMethed == 1) { // 只有一种登录方式：扫码
          if (this.qrcode) {
            Message.error('已生成登录二维码，请勿频繁操作登录方式');
          } else {
            this.getQrcode();
          }
        }
      });
    },
    // 点击扫码登录
    creatQrcode(){
      this.registerMode = this.registerMode=='scanCode'?'password':'scanCode'
      if(this.registerMode == 'scanCode'){
        if (this.qrcode) {
          // Message.error('已生成登录二维码，请勿频繁操作登录方式');
        } else {
          this.getQrcode();
        }
      }
    },
    tabClick(val) { // 登录方式切换
      this.registerMode = val.paneName;
      if (val.paneName == 'scanCode') {
        if (this.qrcode) {
          Message.error('已生成登录二维码，请勿频繁操作登录方式');
        } else {
          this.getQrcode();
        }
      }
    },
    getQrcode() { // 获取随机二维码id
      api.getQrcode({}, (res) => {
        console.log('res', res);
        if (res) {
          this.qrcodeData.qrcodeId = res;
          this.qrcodedraw();
          this.getCodeSetInterval(600);
        }
      });
    },
    qrcodedraw() { // 生成二维码
      document.getElementById('qrcode').innerHTML = '';
      // 需要区分是一种登录方式（220宽高）还是两种登录方式（170宽高），因为二维码的宽高不一样。
      if (this.orgInfo.loginMethed == 3) { // 两种登录方式（170宽高)
        this.qrcode = new QRCode('qrcode', { // QRCode.js是一个用于生成二维码的 JavaScript 库
          width: 170, // 二维码宽度
          height: 170, // 二维码高度
          text: JSON.stringify(this.qrcodeData),
          background: '#ffffff', // 二维码的后景色
          foreground: '#000000', // 二维码的前景色
          correctLevel: QRCode.CorrectLevel.H,
        });
      } else { // 一种登录方式（220宽高）
        this.qrcode = new QRCode('qrcode', { // QRCode.js是一个用于生成二维码的 JavaScript 库
          width: 220, // 二维码宽度
          height: 220, // 二维码高度
          text: JSON.stringify(this.qrcodeData),
          background: '#ffffff', // 二维码的后景色
          foreground: '#000000', // 二维码的前景色
          correctLevel: QRCode.CorrectLevel.H,
        });
      }
      this.ifInterval = true;
      this.getQrcodeScanResult(); // 生成二维码后调取接口获取扫码结果
      document.getElementById('qrcode').title = ''; // 插件生成二维码会将二维码的内容以鼠标移入方式展示，手动清空
    },
    qrcodeDestroy() { // 销毁二维码
      // this.websocketclose()
      this.qrcode && this.qrcode.clear();
      document.getElementById('qrcode').innerHTML = ''; // 清掉二维码，不然会累积
    },
    clickModalDownload() { // 点击下载地址文本
      this.modalDownload = true;
    },
    codeRefresh() { // 刷新二维码
      this.imgCode = false;
      // 销毁二维码
      api.getDestroyQrcode({ qrcodeId: this.qrcodeData.qrcodeId }, (res) => {
        this.getCodeSetInterval(0); // 清空定时器
        this.qrcodeData.qrcodeId = '';
        this.showCode = 0;
        this.$nextTick(() => { // 生成二维码
          this.getQrcode();
        });
      });
    },
    getQrcodeScanResult() { // 2s获取一次扫码结果
      const _this = this;
      const qrCodeId = Object.prototype.toString.call(this.qrcodeData.qrcodeId) === '[object Object]' ? '' : this.qrcodeData.qrcodeId; // 判断是否为对象
      if (this.ifInterval) {
        if (qrCodeId === '') {
          Message.error('请稍后刷新页面再试~');
          return;
        } // 以前的处理方式是每2s请求一次，网络慢的情况下，可能会下一个请求开始了上一个请求才返回信息导致有bug，现在改成了上一个请求返回后再进行下一个请求。
        const timer = () => {
          _this.qrcodesetInterval = setTimeout(() => {
            console.log('-----开始跑定时器-----');
            api.getQrcodeScanResult({ qrcodeId: qrCodeId }, (res) => {
              if (res && res) {
                console.log('-----succcess-----');
                const redata = res;
                if (redata.detailErrorCode && redata.detailErrorCode == 'CRM00014') {
                  this.showCode = 1;
                  timer();
                } else if (redata.pcToken) {
                  window.localStorage.setItem('registerMode', this.registerMode);
                  window.localStorage.setItem('isLoginState', 'true');
                  const url = `${this.locationUrl}?token=${redata.pcToken}`;
                  console.log('🚀 ~ file: Login.vue ~ line 559 ~ _this.qrcodesetInterval=setInterval ~ url', url);
                  this.setCookie('hrefUrl', url, 5, true);
                  window.location.href = encodeURI(url);

                  this.ifInterval = false;
                  // clearInterval(_this.qrcodesetInterval);
                  _this.qrcodesetInterval = null;
                } else {
                  timer();
                  console.log('redata', redata);
                }
              } else {
                console.log('-----fail-----');
                timer();
              }
            });
          }, 2000);
        };
        timer();
      } else {
        // clearInterval(_this.qrcodesetInterval);
        _this.qrcodesetInterval = null;
      }
    },
    getCodeSetInterval(num) { // 二维码倒计时
      const _this = this;
      let _num = num;
      if (_num == 0) {
        this.showCode = 0;
        clearInterval(_this.codeSetInterval);
        _this.codeSetInterval = null;
        this.imgCode = true;
        this.ifInterval = false;
        this.getQrcodeScanResult();
        this.qrcodeDestroy();
      } else {
        this.imgCode = false;
        _this.codeSetInterval = setInterval(() => {
          --_num;
          console.log(_num);
          if (_num == 0) {
            _this.showCode = 2;
            clearInterval(_this.codeSetInterval);
            this.imgCode = true;
            this.ifInterval = false;
            this.getQrcodeScanResult();
            this.qrcodeDestroy();
          }
        }, 1000);
      }
    },
    inputChange(val) { // 图片验证码输入框值发生变化
      if (window.canNotSetShowCodeFalse) {
        return;
      }
      this.isSend = false;
      this.isShowCode = false;
      if (this.loginForm.validCode) {
        this.loginForm.validCode = '';
      }
    },
    inputClear() { // 图片验证码输入框点击清空
      this.inputChange();
    },
    closeDiv(type) { // 清除表单
      if (type == 1) {
        this.$refs.alterForm.resetFields();
        this.getSetInterval(0);
      } else if (type == 2) {
        this.getSetInterval(0);
        this.$refs.verificationForm.resetFields();
        this.butInput = true;
      }
    },
    onSuccess() { // 图片拖动验证,验证通过，发送验证码
      this.modalStatus = false;
      const obj = { phone: this.alterForm.phone, validType: '', userId: this.loginForm.userId };
      if(['register','verificationCode'].includes(this.registerMode)){//注册和验证码登录
        let phone = this.registerMode == 'register'?this.registerForm.phone:this.verificationCodeForm.phone
        let postData ={
          phone:phone,
          validType:this.registerMode == 'register'?'ORG_REGISTER':'LOGIN_PHONE',
        }
        api.getValidCode(postData, (res) => {
          if (res) {
            Message.success({ message: '发送成功' })
            // 成功拿到验证码，修改按钮状态,60秒倒计时
            this.getSetInterval(60);
          }
          if (res.code == 'AUTH001') {
            Message.warning({ message: '长时间没操作界面，2秒后会刷新，请重试！' });
            setTimeout(() => {
              window.sessionStorage.removeItem('timestampGap');
              window.location.reload();
            }, 2000);
          }
        })
        return
      }
      if (this.verificationDialog) {
        obj.validType = 'LOGIN';
        api.getSendCode(obj, (res) => { // 登录获取验证码
          if (res) {
            this.butInput = false;
            Message.success({ message: '发送成功' });
            // 成功拿到验证码，修改按钮状态,60秒倒计时
            this.getSetInterval(60);
          }
          if (res.code == 'AUTH001') {
            Message.warning({ message: '长时间没操作界面，2秒后会刷新，请重试！' });
            setTimeout(() => {
              window.sessionStorage.removeItem('timestampGap');
              window.location.reload();
            }, 2000);
          }
        });
      } else {
        obj.validType = 'FIND_PASSWORD';
        api.sendCode(obj, (res) => { // 修改默认密码获取验证码
          if (res) {
            Message.success({ message: '发送成功' });
            // 成功拿到验证码，修改按钮状态,60秒倒计时
            this.getSetInterval(60);
          }
        });
      }
    },
    getSetInterval(num) { // 验证码倒计时
      const _this = this;
      let _num = num;
      if (num == 0) {
        _this.sendStatus = false;
        _this.sendCodeText = '发送验证码';
        clearInterval(_this.interval);
        _this.interval = null;
      } else {
        _this.interval = setInterval(() => {
          _this.sendCodeText = `重发(${--_num}s)`;
          _this.sendStatus = true;
          if (_num == 0) {
            _this.sendStatus = false;
            _this.sendCodeText = '发送验证码';
            clearInterval(_this.interval);
          }
        }, 1000);
      }
    },
    getSubmit() { // 修改默认密码提交
      this.$refs.alterForm.validate((valid) => {
        if (valid) {
          const obj = {
            code: this.alterForm.code,
            phone: this.alterForm.phone,
            passwd: this.alterForm.passwd,
            confirmPasswd: this.alterForm.confirmPasswd,
            userId: this.userId,
            validType: 'FIND_PASSWORD',
            isSampleUpdate: 1,
          };
          api.getBackPassword(obj, (res) => {
            console.log('getSubmit -> res', res);
            if (res) {
              Message.success({
                message: '提交成功',
              });
              this.alterForm = {
                phone: null, // 用户私人手机
                code: '',
                passwd: '',
                confirmPasswd: '',
              };
              this.alterFormDialog = false;
              let obj = {};
              obj.userId = this.loginForm.userId;
              // obj.skipVerifyId = this.randomString();
              obj.skipVerifyId = this.randomStorageString()
              console.log('参数：', obj);
              api.saveUserVerify(obj, (result) => {
                console.log('saveUserVerify:', result);
              });
            }
          });
        }
      });
    },
    // 带了机构ID为0过来
    transRentId(){
      let rentId = window.rentId
      if(rentId===0 || rentId==='0'){
        if(['grey','production'].includes(process.env.NODE_ENV)){
          rentId = 223
        }else{
          rentId = 560
        }
      }
      return rentId
    },
    setLoadingMask(){//整合之前的loading遮罩
      if (window.loadingInstance) {
        window.loadingInstance.close(); // 关闭登录遮罩
        window.loadingInstance = false;
      }
      if (window.coverLoadingTimer) { // 定时器
        window.clearTimeout(window.coverLoadingTimer);
        window.coverLoadingTimer = null;
      }
      // 添加登录遮罩
      window.loadingInstance = Loading.service({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      window.coverLoadingTimer = window.setTimeout(() => {
        if (window.loadingInstance) {
          window.loadingInstance.close(); // 关闭登录遮罩
          window.loadingInstance = false; // 15s的定时器 15s后自动 关闭登录遮罩
        }
      }, 15000);
    },
    // 展示完善信息弹窗
    showCompleteOrgModal(data){
      this.$refs.completeOrgModal.modalData = data
    },
    // 已有账号去登录
    haveAccount(){
      if(this.orgInfo.loginMethed==1){//只有扫码
        this.registerMode = 'scanCode'
      }else{
        this.registerMode = 'password'
      }
    },
    // 注册
    async registerSubmitForm(){
      this.$refs.registerForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          await api.orgRegister(this.registerForm,res=>{
            if(res && res.code==="REQ001"){
              // 展示完善信息弹窗
              this.showCompleteOrgModal({
                status:true,
                phone:this.registerForm.phone,
                locationUrl:this.locationUrl,
              })
            }
          })
          this.loading = false
        }
      })
    },
    // 验证码登录
    async verificationCodeSubmitForm(){
      this.$refs.verificationCodeForm.validate(async (valid) => {
        if (valid) {
          if (this.locationUrl === '') {
            alert('此系统还没有配置跳转路径');
          } else {
            this.loading = true
            // this.loading = true;// 登录按钮loading
            // this.setLoadingMask()
            let res = await api.checkOrgsByPhone(this.verificationCodeForm)
            if(res && res.length>0){
              if(res.length==1){//只有一个机构
                if(res[0].completed){//且完善状态直接登录
                  this.$refs.selectOrgModal.modalData.locationUrl = this.locationUrl
                  this.$refs.selectOrgModal.phoneLogin({
                    phone: this.verificationCodeForm.phone,
                    validCode: this.verificationCodeForm.validCode,
                    rentId: res[0].rentId,
                  },res=>{
                    this.loading = false
                    if(res){//返回没有权限的信息
                      this.dialogVisible = true
                    }
                  })
                }else{
                  // 展示完善信息弹窗
                  this.showCompleteOrgModal({
                    status:true,
                    phone:this.verificationCodeForm.phone,
                    locationUrl:this.locationUrl,
                  })
                  this.loading = false
                }
              }else if(res.length>=1){//多个机构打开弹窗
                this.$refs.selectOrgModal.modalData = {
                  status:true,
                  phone:this.verificationCodeForm.phone,
                  validCode:this.verificationCodeForm.validCode,
                  orgList:res,
                  locationUrl:this.locationUrl,
                }
                this.loading = false
              }
            }else{
            this.loading = false
            }
            /* api.hjxLoginVerify(obj, (_res) => {
              if ((_res && _res.code === 'REQ007') || (_res && _res.code === 'REQ002')) {
                Message.error(_res.msg);
              } else if (_res.menuNos && _res.menuNos !== '') { // 是否有权限登录选中的系统
                const data = JSON.stringify(_res);
                window.localStorage.setItem('registerMode', this.registerMode);
                window.localStorage.setItem('isLoginState', 'true');
                const url = `${this.locationUrl}?token=${JSON.parse(data).token}`;
                setTimeout(() => {
                  window.location.href = encodeURI(url); // 调试，还要打开的
                }, 200);
              } else if (_res) {
                this.dialogVisible = true;
              }
              this.loading = false;// 登录按钮loading
            }); */
          }
        }
      });
    },
    submitForm() { // 登录
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.locationUrl === '') {
            alert('此系统还没有配置跳转路径');
          } else {
            sessionStorage.removeItem('timestampGap');
            this.$tool.getNowTime();
            this.loading = true;// 登录loading
            // const verifyForm = { skipVerifyId: this.randomString() };
            const verifyForm = { skipVerifyId: this.randomStorageString() };
            const obj = Object.assign(verifyForm, this.loginForm);

            if (window.loadingInstance) {
              window.loadingInstance.close(); // 关闭登录遮罩
              window.loadingInstance = false;
            }
            if (window.coverLoadingTimer) { // 定时器
              window.clearTimeout(window.coverLoadingTimer);
              window.coverLoadingTimer = null;
            }
            // 添加登录遮罩
            window.loadingInstance = Loading.service({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)',
            });
            window.coverLoadingTimer = window.setTimeout(() => {
              if (window.loadingInstance) {
                window.loadingInstance.close(); // 关闭登录遮罩
                window.loadingInstance = false; // 15s的定时器 15s后自动 关闭登录遮罩
              }
            }, 15000);
            api.loginVerify(obj, (res) => {
              // console.log(' ===== res === ', res)
              if (window.coverLoadingTimer) {
                window.clearTimeout(window.coverLoadingTimer);
                window.coverLoadingTimer = null;
              }
              if (window.loadingInstance) {
                window.loadingInstance.close(); // 关闭登录遮罩
                window.loadingInstance = false;
              }
              this.userId = res.id;
              this.alterForm.phone = res.teleno;
              this.verificationForm.phone = res.teleno;
              // debugger //打印断点
              if (res) {
                this.verifyType = res.verifyType;
                // 开始检验逻辑
                if (res.code && res.code === 'REQ007') { // 验证码
                  Message.error({
                    message: res.msg,
                  });
                  this.isSend = true;
                  window.canNotSetShowCodeFalse = true;
                  if (window.canNotSetShowCodeFalseTimer) {
                    window.clearTimeout(window.canNotSetShowCodeFalseTimer);
                    window.canNotSetShowCodeFalseTimer = null;
                  }
                  window.canNotSetShowCodeFalseTimer = window.setTimeout(() => {
                    window.canNotSetShowCodeFalse = false;
                  }, 500);
                  this.isShowCode = true;
                  this.$set(this, 'codeImg', `${process.env.VUE_APP_URL}/sys/validateCode?userId=${this.loginForm.userId}&random=${Math.random()}`);
                } else if (res.isSimpleCode == 1) {
                  this.alterFormDialog = true; // 修改密码弹窗
                  this.loading = false;
                } else if (res.code && res.code === 'REQ0011') { // 暂时没有对应的系统权限
                  this.dialogVisible = true;
                } else { // 逻辑需要调整，不用选择模块再进入系统
                  if (res.skipVerify == 1) { // 是否需要手机验证码登录  skipVerify等于0时弹获取手机验证码输入框，1重新调login接口登录
                    // const _loginForm = { skipVerifyId: this.randomString() };
                    const _loginForm = { skipVerifyId: this.randomStorageString() };
                    this.loginForm.module = 'hjx_s2b_platform';
                    if(this.orgInfo.defaultLoginVersion==2){//默认登录3.0beta菜单版本
                      this.loginForm.module = 'hjx_s2b_platform_beta'
                    }
                    const _obj = Object.assign(_loginForm, this.loginForm, { newOpensaas: 1 });
                    api.loginIn(_obj, (_res) => {
                      if ((_res && _res.code === 'REQ007') || (_res && _res.code === 'REQ002')) {
                        Message.error(_res.msg);
                      } else if (_res.menuNos && _res.menuNos !== '') { // 是否有权限登录选中的系统
                        console.log('login login login login');
                        const data = JSON.stringify(_res);
                        if (this.isSavePass) {
                          if (!window.localStorage.getItem('userInfo')) {
                            const userObj = { userId: this.loginForm.userId, passwd: this.loginForm.passwd, timeStamp: (new Date()).getTime() };
                            window.localStorage.setItem('userInfo', JSON.stringify(userObj));
                          } else {
                            const userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
                            if (userInfo.userId != this.loginForm.userId || userInfo.passwd != this.loginForm.passwd) {
                              const userObj = { userId: this.loginForm.userId, passwd: this.loginForm.passwd, timeStamp: (new Date()).getTime() };
                              window.localStorage.setItem('userInfo', JSON.stringify(userObj));
                            }
                          }
                        } else if (window.localStorage.getItem('userInfo')) {
                          window.localStorage.removeItem('userInfo');
                        }
                        window.localStorage.setItem('registerMode', this.registerMode);
                        window.localStorage.setItem('isLoginState', 'true');
                        this.verificationForm = {};
                        this.verificationDialog = false;
                        const url = `${this.locationUrl}?token=${JSON.parse(data).token}`;
                        setTimeout(() => {
                          window.location.href = encodeURI(url); // 调试，还要打开的
                        }, 200);
                      } else if (_res) {
                        this.dialogVisible = true;
                      }
                    });
                  } else {
                    this.verificationDialog = true;
                  }
                }
              }
              this.loading = false;// 登录loading
            });
            this.loading = false;// 登录loading
          }
        }
      });
    },
    getVerification() { // 获取验证码弹窗提交
      this.$refs.verificationForm.validate((valid) => {
        // console.log(this.verificationForm);
        if (valid) {
          const _loginForm = {
            validCode: this.verificationForm.validCode,
            userId: this.loginForm.userId,
            passwd: this.loginForm.passwd,
            module: 'hjx_s2b_platform',
            // skipVerifyId: this.randomString(),
            skipVerifyId: this.randomStorageString(),
          };
          const _obj = Object.assign(_loginForm, { newOpensaas: 1 });
          this.btnLoading = true;
          api.loginIn(_obj, (res) => {
            this.userId = res.id;
            if (res) {
              if ((res.code && res.code === 'REQ007') || (res && res.code === 'REQ002')) {
                Message.error(res.msg);
              } else {
                const data = JSON.stringify(res);
                if (this.isSavePass) {
                  if (!window.localStorage.getItem('userInfo')) {
                    const userObj = { userId: this.loginForm.userId, passwd: this.loginForm.passwd, timeStamp: (new Date()).getTime() };
                    window.localStorage.setItem('userInfo', JSON.stringify(userObj));
                  } else {
                    const userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
                    if (userInfo.userId != this.loginForm.userId || userInfo.passwd != this.loginForm.passwd) {
                      const userObj = { userId: this.loginForm.userId, passwd: this.loginForm.passwd, timeStamp: (new Date()).getTime() };
                      window.localStorage.setItem('userInfo', JSON.stringify(userObj));
                    }
                  }
                } else if (window.localStorage.getItem('userInfo')) {
                  window.localStorage.removeItem('userInfo');
                }
                window.localStorage.setItem('registerMode', this.registerMode);
                window.localStorage.setItem('isLoginState', 'true');
                this.verificationForm = {};
                this.verificationDialog = false;
                const url = `${this.locationUrl}?token=${JSON.parse(data).token}`;
                setTimeout(() => {
                  window.location.href = encodeURI(url);
                }, 200);
              }
            }
            this.btnLoading = false;
          });
          this.btnLoading = false;
        }
      });
    },
    getCode(type) { // 修改默认密码验证码
      switch (type) {
        case 1:
          if (this.alterForm.phone) {
            this.modalStatus = true;
          } else {
            Message.error('请输入手机号码');
          }
          break;
        case 2:
          if (this.verificationForm.phone) {
            this.modalStatus = true;
          } else {
            Message.error('请输入手机号码');
          }
          break;
        case 3:
          // 获取验证码
          let phone = this.registerMode == 'register'?this.registerForm.phone:this.verificationCodeForm.phone
          if (phone) {
            this.modalStatus = true;
          } else {
            Message.error('请输入手机号码')
          }
          break;
        default:
          console.log(type, this.alterForm.phone, this.verificationForm.phone);
      }
    },
    toForgetPass() {
      this.$router.push({ name: 'forgetPass' });
    },
    handleGedCode() {
      // 获取验证码
      this.isSend = true;
      this.isShowCode = true;
      this.$set(this, 'codeImg', `${process.env.VUE_APP_URL}/sys/validateCode?userId=${this.loginForm.userId}&random=${Math.random()}`);
    },
    hanldeBtn(item) {
      this.checkItem = item.id;
      const marginLeft = `${-945 * (item.id - 1)}px`;
      this.rotaryBoxStyle = {
        left: marginLeft,
      };
    },
    cardEnter(item) {
      if (item.QRcode !== '') {
        this.mouseIndex = item.id;
        this.showNoQRcode = 0;
      } else {
        this.mouseIndex = 0;
        this.showNoQRcode = item.id;
      }
    },
    recovery() {
      this.mouseIndex = 0;
      this.showNoQRcode = 0;
    },

    // 设置cookie
    setCookie(cname, cvalue, exdays) {
      const d = new Date();
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      const expires = `expires=${d.toUTCString()}`;
      console.info(`${cname}=${cvalue}; ${expires}`);
      document.cookie = `${cname}=${cvalue}; ${expires}`;
      console.info(document.cookie);
    },
    // 获取cookie
    getCookie(cname) {
      const name = `${cname}=`;
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1);
        if (c.indexOf(name) != -1) {
          return c.substring(name.length, c.length);
        }
      }
      return '';
    },
    randomString() { // 前端生成32位随机数
      if (this.getCookie('skipVerifyId') && this.getCookie('skipVerifyId') != 'NaN') { // 判断缓存是否有skipVerifyId值
        return this.getCookie('skipVerifyId');
      }
      const len = 32;
      const str = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
      const maxPos = str.length;
      let pwd = '';
      for (let i = 0; i < len; i++) {
        pwd += str.charAt(Math.floor(Math.random() * maxPos));
      }
      this.setCookie('skipVerifyId', pwd, 30);
      return pwd;
    },
    // 保留websocket方法，那知道蛇皮产品后面会不会再改一次
    websocketonopen() { // 连接建立之后执行send方法发送数据
      const actions = { qrcodeId: this.qrcodeData.qrcodeId, id: this.qrcodeData.sysModuleId };
      this.websocketsend(JSON.stringify(actions));
    },
    websocketonerror() { // 连接建立失败重连
      this.initWebSocket();
    },
    websocketonmessage(e) { // 数据接收
      const redata = JSON.parse(e.data);
      console.log('🚀 ~ file: Login.vue ~ line 521 ~ websocketonmessage ~ redata', redata);
      if (redata.detailErrorCode && redata.detailErrorCode == 'CRM00014') { // 二维码已扫
        this.showCode = 1;
      } else if (redata.pcToken) {
        this.showCode = 0;
        window.localStorage.setItem('registerMode', this.registerMode);
        window.localStorage.setItem('isLoginState', 'true');
        const url = `${this.locationUrl}?token=${redata.pcToken}`;
        setTimeout(() => {
          window.location.href = encodeURI(url);
        }, 200);
      }
    },
    websocketsend(Data) { // 数据发送
      this.websock.send(Data);
    },
    websocketclose(e) { // 关闭
      console.log('断开连接', e);
    },
    //  1.12 将随机数存localStorage
    setSkipIdStorage(cname, cvalue){
      window.localStorage.setItem(cname,cvalue)
      window.localStorage.setItem('storageTime',new Date().getTime())
    },
    getSkipIdStorage(cname){
      return window.localStorage.getItem(cname)
    },
    randomStorageString() { // 前端生成32位随机数
      if (this.getSkipIdStorage('skipVerifyId') && this.getSkipIdStorage('skipVerifyId') != 'NaN') { // 判断缓存是否有skipVerifyId值
        let storageTime = this.getSkipIdStorage('storageTime')
        let days = (new Date().getTime() - storageTime)/1000/60/60/24
        console.log("相差天数",days);
        if(days < 30){ //判断当前时间与上一次缓存时的时间差值 是不是小于30天
          return this.getSkipIdStorage('skipVerifyId');
        }
        
      }
      const len = 32;
      const str = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
      const maxPos = str.length;
      let pwd = '';
      for (let i = 0; i < len; i++) {
        pwd += str.charAt(Math.floor(Math.random() * maxPos));
      }
      this.setSkipIdStorage('skipVerifyId', pwd);
      return pwd;
    },
  },
};
</script>

<style lang="less" scoped>
  .register-btn{
    text-align: center;
    margin-top: 40px;
    span{
      color: #4677F8;
      cursor: pointer;
    }
  }
  .phone-valid-code-btn{
    position: absolute;
    right: 16px;
    top: 0;
  }
    /deep/.el-dialog__body{
        padding: 0 20px 20px !important;
    }
    .main{
        width: 100%;
        height: 100vh;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
    }
    .normal_main {
        background: url('../assets/images/hjx_bg.png') no-repeat center;
        background-size: 1920px 100%;
    }
    .not_found {
        background: url('');
    }
    .not_found_img {
        width: 641px;
        height: 478px;
    }
    /* logo */
    .logo_img_text {
        position: absolute;
        height: 50px;
        top: 32px;
        left: 34px;
        image-rendering: -moz-crisp-edges;
        image-rendering: -o-crisp-edges;
        image-rendering: -webkit-optimize-contrast;
        image-rendering: crisp-edges;
        -ms-interpolation-mode: nearest-neighbor;
        backface-visibility: hidden;
        -webkit-backface-visibility: hidden;
    }
    /* 验证码 */
    .getCodeBox{
        float: right;
        width: 105px;
        height: 36px;
        img{
            width: 100%;
            height: 100%;
            cursor: pointer;
        }
    }
    /* 底部文字 */
    .bottom_text {
        position: absolute;
        font-size: 14px;
        font-weight: 400;
        color: #949699;
        bottom: 20px;
    }
    .login_card{
        width: 1300px;
        height: 630px;
        background: #ffffff;
        border-radius: 4px;
        box-shadow: 0px 8px 20px 0px rgba(18,101,255,0.06);
    }
    /* 左侧登录背景图 */
    .main-l {
        float: left;
        width: 770px;
        height: 630px;
        background: url('../assets/images/hjx_login_bg.png') no-repeat 0 0;
        background-size: 100% 100%;
        image-rendering: -moz-crisp-edges;
        image-rendering: -o-crisp-edges;
        image-rendering: -webkit-optimize-contrast;
        image-rendering: crisp-edges;
        -ms-interpolation-mode: nearest-neighbor;
        backface-visibility: hidden;
        -webkit-backface-visibility: hidden;
    }
    .main-r {
      position: relative;
        display: flex;
        flex-direction: row;
        justify-content: center;
        .login_text {
            text-align: center;
            font-size: 28px;
            font-weight: 700;
            color: #343537;
            margin-top: 100px;
            width: 385px;
            white-space: nowrap;
        }
        .login_wrap {
            padding-top: 100px;
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        .paddingSmall {
            padding-top: 30px;
        }
        .paddingNormal {
            padding-top: 55px;
        }
        .login_btn {
            margin-top: 6px;
            width:320px;
            height:46px;
            font-size:16px;
            border:none;
            background-color: #5886ff;
            background-image: linear-gradient(to right, #5886ff , #376af2);
            border-radius: 4px;
            box-shadow: 0px 3px 8px 0px rgba(57,109,243,0.25);
        }
    }
    .forgetPass{
        cursor: pointer;
        float: right;
        margin: 0px;
        &:hover{
            color:#2d8cf0 ;
        }
    }

    .login_form{
        text-align: center;
    }
    .login_text {
        text-align: center;
        font-size: 28px;
        font-weight: 700;
        color: #343537;
        margin-top: 90px;
        width: 385px;
        white-space: nowrap;
    }
    .spanText{
        font-size: 16px;
        color:#4677F8;
        cursor:pointer;
    }
    /* 只有一种登录方式：账号密码登录 */
    .login_wrap {
        padding-top: 100px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .only_login_text {
        margin-top: 100px;
    }
    .login_btn {
        margin-top: 8px;
        width:320px;
        height:46px;
        font-size:16px;
        border:none;
        background-color: #5886ff;
        background-image: linear-gradient(to right, #5886ff , #376af2);
        border-radius: 4px;
        box-shadow: 0px 3px 8px 0px rgba(57,109,243,0.25); 
    }
    /* 只有一种登录方式：扫码登录 */
    .login_code_wrap {
        padding-top:52px;
        text-align: center;
        p {
            font-size:18px;
            color:#595656;
            line-height: 1;
        }
    }
    .one_way_code{
        margin:34px 0 28px;
        position: relative;
        font-size: 16px;
        font-weight: 400;
        .codeRefreshClass{
            position: absolute;
            top:0;
            left:83px;
            width:220px;
            height:220px;
            background-color: rgba(205, 205, 205, 0.9);
            cursor:pointer;
        }
        .qrcode {
            display: inline-block;
            img{
                display: inline-block !important;
            }
        }
    }
    /* 两种登录方式 */  
    .login_wrap_all {
        padding-top: 55px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .paddingAPNormal {
        padding-top: 22px;
    }
    .paddingAPSmall {
        padding-top: 18px;
    }
    .login_btn_all {
        margin-top: 0px;
        width:320px;
        height:46px;
        font-size:16px;
        border:none;
        background-color: #5886ff;
        background-image: linear-gradient(to right, #5886ff , #376af2);
        border-radius: 4px;
        box-shadow: 0px 3px 8px 0px rgba(57,109,243,0.25); 
    }
    .login_btn_showcode {
        margin-top: -20px;
        width:320px;
        height:46px;
        font-size:16px;
        border:none;
        background-color: #5886ff;
        background-image: linear-gradient(to right, #5886ff , #376af2);
        border-radius: 4px;
        box-shadow: 0px 3px 8px 0px rgba(57,109,243,0.25); 
    }
    .code{
        margin:36px 0 30px;
        position: relative;
        font-size: 16px;
        font-weight: 400;
        .qrcode {
            display: inline-block;
            img{
                display: inline-block !important;
            }
        }
    }
    .codeRefreshClass2{
        position: absolute;
        top:0;
        left:75px;
        width:170px;
        height:170px;
        background-color: rgba(205, 205, 205, 0.9);
        cursor:pointer;
    }
</style>
<style lang="less">
  img{
      -webkit-user-drag: none;
  }
    .login_form .el-input--small .el-input__inner{
        height: 40px;
        font-size: 14px;
    }
    .login_form .el-input--prefix .el-input__inner {
        padding-left: 34px !important;
    }
    .login_form .account_icon{
        padding-left: 30px;
        margin-left: -10px;
        background: url('../assets/images/hjx_zhanghao.png') no-repeat 10px center;
        background-size: 24px 24px;
    }
    .login_form .pwd_icon{
        padding-left: 30px;
        margin-left: -8px;
        background: url('../assets/images/hjx_mima.png') no-repeat 10px center;
        background-size: 22px 22px;
    }
    .el-form-item{
        margin-bottom: 28px;
    }
    @media screen and (max-width: 1380px) {
        .el-form-item{
            margin-bottom: 16px;
        }
        /* logo */
        .logo_img_text {
            position: absolute;
            height: 40px;
            top: 32px;
            left: 34px;
            image-rendering: -moz-crisp-edges;    
            image-rendering: -o-crisp-edges;  
            image-rendering: -webkit-optimize-contrast; 
            image-rendering: crisp-edges; 
            -ms-interpolation-mode: nearest-neighbor;
            backface-visibility: hidden;
            -webkit-backface-visibility: hidden;
        }
        .login_card{
            width: 1030px !important;
            height: 500px !important;
        }
        /* 左侧登录背景图 */
        .main-l {
            width: 614px !important; 
            height: 500px !important;
        }
        .code{
            margin:10px 0 6px !important;
        }
        .main {
            .main-r {
                .login_text {
                    text-align: center;
                    font-size: 28px;
                    font-weight: 700;
                    margin-top: 70px !important;
                }
                .login_wrap {
                    padding-top: 48px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }
                .login_btn_showcode {
                    margin-top: -26px;
                }
                .paddingSmall {
                    padding-top: 0px;
                }
                .paddingNormal {
                    padding-top: 40px;
                }
                .login_btn {
                    width:320px;
                    height:39px;
                    font-size:16px;
                }
            }
            .logo_img_text {
                position: absolute;
                height: 38px;
                top: 20px;
                left: 34px;
                image-rendering: -moz-crisp-edges;
                image-rendering: -o-crisp-edges;
                image-rendering: -webkit-optimize-contrast;
                image-rendering: crisp-edges;
                -ms-interpolation-mode: nearest-neighbor;
                backface-visibility: hidden;
                -webkit-backface-visibility: hidden;
            }
            .login_form .code {
                margin: 0px 0px 10px;
            }
            .one_way_code {
                margin: 24px 0 12px;
            }
            /* 两种登录方式 */  
            .login_wrap_all {
                padding-top: 20px;
                display: flex;
                flex-direction: column;
                align-items: center;
            }
            .paddingAPNormal {
                padding-top: 18px;
            }
            .paddingAPSmall {
                padding-top: 8px;
            }
            .login_btn {
                margin-top: 8px;
            }
            /* 一种登录方式小屏情况 */
            .login_form_small {
                .el-form-item{
                    margin-bottom: 28px !important;
                }
            }
        }
    }
    @media screen and (max-height:830px){
        .el-form-item {
            margin-bottom: 16px;
        }
        /* logo */
        .logo_img_text {
            position: absolute;
            height: 40px;
            top: 32px;
            left: 34px;
            image-rendering: -moz-crisp-edges;    
            image-rendering: -o-crisp-edges;  
            image-rendering: -webkit-optimize-contrast; 
            image-rendering: crisp-edges; 
            -ms-interpolation-mode: nearest-neighbor;
            backface-visibility: hidden;
            -webkit-backface-visibility: hidden;
        }
        .login_card{
            width: 1030px !important;
            height: 500px !important;
        }
        /* 左侧登录背景图 */
        .main-l {
            width: 614px !important; 
            height: 500px !important;
        }
        .code{
            margin:10px 0 6px !important;
        }
        .main {
            .main-r {
                .login_text {
                    text-align: center;
                    font-size: 28px;
                    font-weight: 700;
                    margin-top: 70px !important;
                }
                .login_wrap {
                    padding-top: 48px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }
                .login_btn_showcode {
                    margin-top: -26px;
                }
                .paddingSmall {
                    padding-top: 0px;
                }
                .paddingNormal {
                    padding-top: 40px;
                }
                .login_btn {
                    width:320px;
                    height:39px;
                    font-size:16px;
                }
            }
            .login_form .code {
                margin: 0px 0px 10px;
            }
            .only_login_text {
                margin-top: 44px;
                margin-bottom: 50px;

            }
             .one_way_code {
                margin: 24px 0 12px;
            }
            /* 两种登录方式 */  
            .login_wrap_all {
                padding-top: 14px;
                display: flex;
                flex-direction: column;
                align-items: center;
            }
            .paddingAPNormal {
                padding-top: 18px;
            }
            .paddingAPSmall {
                padding-top: 8px;
            }
        }
    }
    @media screen and (max-height:700px){
        .logo_img_text {
            top: 20px !important;
        }
        .main {
            justify-content: flex-start !important;
            padding-top: 90px !important;
        }
    }
    /* 切换登录模式 */
    .change-login-type-btn{
      cursor: pointer;
      height: 70px;
      position: absolute;
      right: 0;
      top: 0;
    }
</style>
